export default __webpack_public_path__ + "static/media/gd.3a634a9f.svg";